// extracted by mini-css-extract-plugin
export var card = "_j1-5";
export var cardSelected = "_j1-4";
export var image = "_j1-3";
export var modal = "_j1-0";
export var modalContent = "_j1-1";
export var table = "_j1-2";